module.exports = __webpack_public_path__ + "static/img/btn_index_line.b2206c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_index_line.png
// module id = EVAd
// module chunks = 1